module.exports = __webpack_public_path__ + "assets/img/saugesne-energija.2f8ae50c.webp";